var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videos"},[_vm._t("default"),_c('div',{staticClass:"v"},_vm._l((20),function(item){return _c('div',{key:item,staticClass:"video"})}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }